import '../invoice.scss';

import isEmpty from 'lodash/isEmpty';
import { arrayOf, bool, func } from 'prop-types';
import React from 'react';
import Moment from 'react-moment';
import { Col, Collapse, Row } from 'reactstrap';

import ExpandButton from '../../../generic/ExpandButton';
import SignedCurrencyFormat from '../../../generic/SignedCurrencyFormat';
import InvoiceLink from '../../../invoices/InvoiceLink';
import StatusBadge from '../../../invoices/StatusBadge';
import { calculateTotalSum } from '../../../invoices/utils';
import { MerchantLinks } from '../../../merchants/Link';
import { salesChannelsEnum } from '../../../opportunities/constants';
import { invoiceShape, productShape } from '../../../prop-types';
import QuoteLink from '../../../quotes/QuoteLink';
import UserLink from '../../../users/UserLink';
import { UI_SHORT_DATE_FORMAT } from '../../../utils/constants';
import ListBookingEntries from '../../booking-entries/ListBookingEntries';
import { allStatusesEnum } from '../../constants';
import UpdateInvoiceStatusButton from '../UpdateInvoice/UpdateInvoiceStatusButton';

export default class ApprovableInvoiceLine extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggle = this.handleToggle.bind(this);
    this.state = { expanded: true };
  }

  handleToggle() {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  }

  render() {
    const {
      invoice,
      products,
      loading,
      onUpdateStatus,
      onIsSelected,
      onToggleSelection,
    } = this.props;
    const { expanded } = this.state;

    const invoiceId = invoice.id;
    const { salesChannel } = invoice;
    return (
      <>
        <div className="c-balance-line c-invoice-line c-invoice-line__header p-3">
          <Row className="d-flex align-items-top">
            <Col sm={2}>
              <h4 className="px-0 d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={onIsSelected(invoice.id)}
                  className="mr-2"
                  onChange={() => onToggleSelection(`select-${invoiceId}`)}
                />
                {!isEmpty(invoice.bookingEntries) && (
                  <div className="mr-2">
                    <ExpandButton
                      expanded={expanded}
                      onClick={this.handleToggle}
                    />
                  </div>
                )}
                <InvoiceLink model={invoice} />
              </h4>
              <div data-qa-field="inv-invoiceCreationDate" className="mt-2">
                <Moment format={UI_SHORT_DATE_FORMAT}>{invoice.created}</Moment>
                <div className="small text-muted">Creation Date</div>
              </div>
              <div className="mt-2">
                <UserLink model={invoice.owner} verbose />
                <div className="small text-muted">Owner</div>
              </div>
            </Col>
            <Col sm={2}>
              <div data-qa-field="inv-name">
                <div className="text-truncate">{invoice.name}</div>
                <div className="small text-muted">Name</div>
              </div>
              <div data-qa-field="inv-billingType" className="mt-2">
                {invoice.billingType}
                <div className="small text-muted">Billing Type</div>
              </div>
              <div data-qa-field="inv-businessModel" className="mt-2">
                {invoice.opportunity.businessModel || '-'}
                <div className="small text-muted">Business Model</div>
              </div>
            </Col>
            <Col sm={2}>
              <div data-qa-field="inv-purchaseOrderNumber">
                {invoice.purchaseOrderNumber || '-'}
                <div className="small text-muted">PO number</div>
              </div>
              <div className="mt-2" data-qa-field="inv-quote">
                {invoice.quote ? (
                  <QuoteLink
                    className="d-block text-truncate"
                    model={invoice.quote}
                  />
                ) : (
                  '-'
                )}
                <div className="small text-muted">Quote</div>
              </div>
              <div className="mt-2" data-qa-field="inv-type">
                {invoice.type}
                <div className="small text-muted">Type</div>
              </div>
            </Col>
            <Col sm={2}>
              <div data-qa-field="inv-account">
                {salesChannel !== salesChannelsEnum.SELF_SERVICE && (
                  <>
                    <span>{invoice.accountSfId}</span>
                    <div className="small text-muted">Billing Account</div>
                  </>
                )}
                {salesChannel === salesChannelsEnum.SELF_SERVICE && (
                  <>
                    <MerchantLinks models={invoice.merchants} />
                    <div className="small text-muted">Merchants</div>
                  </>
                )}
              </div>
              <div className="mt-2" data-qa-field="inv-ccInternalUser">
                {invoice.ccInternalUser ? (
                  <UserLink model={invoice.ccInternalUser} />
                ) : (
                  '-'
                )}
                <div className="small text-muted">CC Internal user</div>
              </div>
            </Col>
            <Col sm={1} data-qa-field="inv-amount">
              <SignedCurrencyFormat
                value={calculateTotalSum(invoice.bookingEntries)}
              />
            </Col>
            <Col sm={3} className="text-right">
              {invoice.status === allStatusesEnum.IN_REVIEW.value ? (
                <UpdateInvoiceStatusButton
                  invoice={invoice}
                  className="btn-sm"
                  disabled={loading}
                  status={invoice.status}
                  onUpdateStatus={onUpdateStatus}
                />
              ) : (
                <StatusBadge status={invoice.status} />
              )}
            </Col>
          </Row>
        </div>

        <Collapse isOpen={expanded} className="inv-details-form">
          {!isEmpty(invoice.bookingEntries) && (
            <ListBookingEntries
              data={invoice.bookingEntries}
              products={products}
              invoice={invoice}
              readOnly
            />
          )}
        </Collapse>
      </>
    );
  }
}

ApprovableInvoiceLine.propTypes = {
  invoice: invoiceShape.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  loading: bool.isRequired,
  onUpdateStatus: func.isRequired,
  onToggleSelection: func.isRequired,
  onIsSelected: func.isRequired,
};
